"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinUtils = void 0;
const lodash_1 = require("lodash");
const Pin_1 = require("./Pin");
class PinUtils {
    /** force casts the pin to the specified type. only use this if you are sure the pin type can't be anything else */
    // TODO: Remove probably?
    static contentOfType(pin) {
        return pin.settings;
    }
}
exports.PinUtils = PinUtils;
PinUtils.isPinType = (string) => !!string && Pin_1.allPinTypes.includes(string);
PinUtils.isInteractive = (pin) => !(0, lodash_1.isNil)(pin) && (0, lodash_1.some)(Pin_1.pinInteractiveTypes, (t) => t == pin.type);
PinUtils.typeIsInteractive = (pinType) => !!pinType && Pin_1.pinInteractiveTypes.includes(pinType);
//# sourceMappingURL=PinUtils.js.map